/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ActivityIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "activity", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M21 15H19L15.5 7L11 18L8 12L6 15H4", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ActivityIcon);
export default ForwardRef;
//# sourceMappingURL=activityIcon.js.map